import { FilterType } from '../../../../interfaces/Filter.interfaces';
import { SlideConfirmModal } from '../../modal/slide/SlideConfirmModal';
import { DirectDealFilterController } from './components/DirectDealFilterController/DirectDealFilterController';
import { FilterController } from './components/FilterController/FilterController';

interface FilterSlideModalProps {
  isShow: boolean;
  closeModal: () => void;
  filterType: FilterType;
}

export const FilterSlideModal = ({ isShow, closeModal, filterType }: FilterSlideModalProps) => {
  return (
    <SlideConfirmModal
      isShow={isShow}
      height={700}
      element={
        // 직거래 리스트는 항목 구성과 선택 방식이 달라 전용 바텀시트를 쓴다.
        filterType === 'directDealFilter' ? (
          <DirectDealFilterController closeModal={closeModal} />
        ) : (
          <FilterController closeModal={closeModal} filterType={filterType} />
        )
      }
      closeButton={{ handleClick: closeModal }}
      isShowCloseButton
      gap={'0px'}
      padding={'0px'}
    />
  );
};
